export const TIME_ZONE_GET_SUCCESS = 'TIME_ZONE_GET_SUCCESS';
export const TIME_ZONE_GET_FAIL = 'TIME_ZONE_GET_FAIL';
export const TIME_ZONE_GET_REQUEST = 'TIME_ZONE_GET_REQUEST';
export const TIME_ZONE_SUCCESS_MESSAGE = 'TIME_ZONE_LISTED_SUCCESSFULLY';
